import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, CalendarDays, MapPin, Download } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

const MesJoursFeriesCalendarInfo = ({ calendar, holidays, exportToICS }) => {
  const { t } = useTranslation();

  if (!calendar) return null;

  return (
    <Card className="border-border">
      <CardHeader>
        <div className="flex items-start justify-between">
          <div>
            <CardTitle className="text-foreground">{calendar.name}</CardTitle>
            <CardDescription>{t("myHolidaysComponents.calendarInfo.description")}</CardDescription>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={exportToICS}
          >
            <Download className="mr-2 h-4 w-4" />
            {t("myHolidaysComponents.calendarInfo.export")}
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-4">
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-xs text-muted-foreground">{t("holidayCommon.fields.year")}</p>
              <p className="font-medium text-foreground">{calendar.year}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-xs text-muted-foreground">{t("holidayCommon.fields.country")}</p>
              <p className="font-medium text-foreground">{calendar.country}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <CalendarDays className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="text-xs text-muted-foreground">{t("myHolidaysComponents.calendarInfo.holidays")}</p>
              <p className="font-medium text-foreground">{holidays.length}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default MesJoursFeriesCalendarInfo;
